<template>
	<collapse-transition>
		<ul class="ui-tree">
			<li
				v-for="(item, index) in menuList"
				:class="[
					'tree-item',
					active === item[activeLabel] ? 'is-active' : '',
				]"
				:key="index"
			>
				<div
					:style="{ paddingLeft: paddingLeft + 'px' }"
					class="tree-item-content"
					@click="toggle(item)"
				>
					<span>{{ item[props.label] }}</span>
					<i
						@click.stop="openChild(index, item)"
						v-if="
							item[props.children] &&
								item[props.children].length > 0
						"
						:class="[
							'el-icon-arrow-down',
							item.opened
								? 'el-icon-arrow-trans-down'
								: 'el-icon-arrow-trans-up',
						]"
					></i>
				</div>
				<!-- <transition name="draw"> -->
				<Item
					v-show="item.opened"
					v-if="
						item[props.children] && item[props.children].length > 0
					"
					:menuList="item[props.children]"
					:props="props"
					:activeLabel="activeLabel"
					:active="active"
					@selected="selected"
					:paddingLeft="padding"
				></Item>
				<!-- </transition> -->
			</li>
		</ul>
	</collapse-transition>
</template>
<script>
/*
 * menuList 菜单列表
 * active 被选中的
 * activeLabel 匹配设置选中的key
 */
import CollapseTransition from "./collapse-transition";
export default {
	name: "Item",
	components: {
		"collapse-transition": CollapseTransition,
	},
	props: {
		menuList: {
			type: Array,
			default: () => {
				return [];
			},
		},
		props: {
			type: Object,
			default: () => {
				return {
					children: "children",
					label: "label",
				};
			},
		},
		active: {
			type: String,
			default: "",
		},
		activeLabel: {
			type: String,
			default: "",
		},
		paddingLeft: {
			type: [String, Number],
			default: "20",
		},
	},
	computed: {},
	data() {
		return {
			open: false,
			padding: this.paddingLeft,
		};
	},
	created() {
		this.actived = this.active;
		this.padding = +this.paddingLeft + 16;
	},
	methods: {
		// 设置展开的数据
		toggle(item) {
			this.$emit("selected", item);
		},
		openChild(index, item) {
			item.opened = !item.opened;
			this.$set(this.menuList, index, item);
		},
		selected(data) {
			this.$emit("selected", data);
		},
	},
};
</script>
<style lang="scss">
.ui-tree {
	.tree-item {
		list-style: none;
		margin: 0;
		.tree-item-content {
			height: 52px;
			line-height: 52px;
			font-size: 14px;
			color: #303133;
			padding: 0 20px;
			list-style: none;
			cursor: pointer;
			position: relative;
			transition: border-color 0.3s, background-color 0.3s, color 0.3s;
			box-sizing: border-box;
			white-space: nowrap;
			padding-left: 26px;
			text-align: left;
			&:hover {
				outline: none;
				color: #5fadfd;
				// transform: scale(1.1);
			}
			.el-icon-arrow-down {
				position: absolute;
				right: 20px;
				top: 20px;
			}
		}
		.el-icon-arrow-trans-up {
			transition: transform ease-in 0.3s;
		}
		.el-icon-arrow-trans-down {
			transform: rotate(-180deg);
			transition: transform ease-in 0.3s;
		}
	}
	.is-active {
		> .tree-item-content {
			color: #5fadfd;
			background-color: #f5f7fa;
		}
	}
}
</style>
